const doc = [({"en":({"js":({"admin":({"tenants":({"integrations":({"inventio":({"the_settings_were_saved":"The settings were saved"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;